import config from 'config'

import { MenuButton, MenuItem, MenuList } from 'tools/Menu'
import { Icon } from 'tools/Uniform'
import { freeze } from 'utils/dom'

import { UserAvatar } from 'app/Avatar'
import { NavButton, StatefulLink, useExpandVisible, useVisible } from 'app/Nav'
import { MENUS, SITEMAP, pathTo } from 'libreon/routes'

const TRANSPARENT = { color: 'transparent' }

const HOME_STYLE = freeze({ height: '2rem', transform: 'scaleX(-1)' })

export function LibreonMenu({ disabled, className = '' }) {
  const visible = useExpandVisible(MENUS.app.items, 'appSub')

  return (
    <NavButton
      Type={MenuButton}
      icon="menuBars"
      wrapClass={className}
      img={
        <div className="flex-items gh2">
          <img
            className="logo db"
            src={config.logo.small}
            alt={config.name}
            style={HOME_STYLE}
          />
          <Icon type="menuPull" style={disabled ? TRANSPARENT : undefined} />
        </div>
      }
      menu={
        <div className="base-navbar z-2">
          <MenuList>
            <div className="theme-dark">
              <div className="navmenu flex flex-column pb2">
                {visible.map(({ id, args }) => (
                  <LibreonItem navId={id} key={id} args={args} />
                ))}
              </div>
            </div>
          </MenuList>
        </div>
      }
    />
  )
}

function LibreonItem({ navId, args }) {
  const elem = SITEMAP[navId]

  if (args.divider) {
    return (
      <div className="f1 pl3 ttu bg-dark-gray flex-items gh2 bt mt1 pv1">
        {elem.nav.icon && <Icon type={elem.nav.icon} />}
        <div className="truncate wmax5">{elem.nav.divName(args)}</div>
      </div>
    )
  }

  return (
    <MenuItem>
      <StatefulLink
        navId={navId}
        name={elem.nav.name(args)}
        tabData={args}
        className="db ph2 pv1"
        inactiveClass=""
        activeClass=""
      />
    </MenuItem>
  )
}

////////////////////////////////////////////////////////////////////////////////
export function SiteMenu({ routeId, noIdent, avatar }) {
  const visible = useVisible(MENUS.site.items, 'site')

  if (noIdent) return <SignOn />

  return (
    <NavButton
      Type={MenuButton}
      wrapClass=""
      menu={
        <div className="base-navbar z-2">
          <MenuList>
            <div className="theme-dark">
              <div className="navmenu flex flex-column pb2">
                {visible.map(({ id, args }) => (
                  <MenuItem key={id}>
                    <StatefulLink
                      navId={id}
                      name={SITEMAP[id].nav.name(args)}
                      tabData={args}
                      className="db ph2 pv1"
                      inactiveClass=""
                      activeClass=""
                    />
                  </MenuItem>
                ))}
              </div>
            </div>
          </MenuList>
        </div>
      }
    >
      <div className="menuitems flex-center flex-column fw3 f1">
        <UserAvatar avatar={avatar} size="thumb" className="db br5 br-pill" />
        <div className="flex-items">
          Me <i className="ml2 f1 fas fa-chevron-down" />
        </div>
      </div>
    </NavButton>
  )
}

function SignOn() {
  return (
    <NavButton to={pathTo('auth_signon')} icon="signon">
      Sign In
    </NavButton>
  )
}

export function NavButtons({ sectionId }) {
  const visible = useVisible(MENUS.app.items, 'app')

  return visible.map(({ id, args }) => {
    const item = SITEMAP[id]
    return (
      <NavButton
        key={id}
        to={item.pathTo()}
        icon={item.nav.icon}
        active={id === sectionId}
      >
        {item.title()}
      </NavButton>
    )
  })
}
